import { render } from "./ContentShow.vue?vue&type=template&id=4c737376"
import script from "./ContentShow.vue?vue&type=script&lang=js"
export * from "./ContentShow.vue?vue&type=script&lang=js"
script.render = render

export default script